import Model, { attr, hasMany, type AsyncHasMany } from '@ember-data/model';
import type { Type } from '@warp-drive/core-types/symbols';
import type InitiativeModel from './initiative';

export default class ThemeModel extends Model {
  declare [Type]: 'theme';
  @attr('string') declare title: string;
  @attr('string') declare color: string;
  @hasMany('initiative', {
    async: true,
    inverse: 'theme',
  })
  declare initiatives: AsyncHasMany<InitiativeModel>;
}
